import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    adsCode:"",
    linkInfo: {
      openLink: '',
      resourceUrl: ''
    },
    queryInfo: {
      adsCode: '',
      tenantCode: ''
    },
    errInfo: {
      msg: '',
      showTip: false
    }
  },
  mutations: {
    getCode(state,payload){
      state.adsCode=payload
    },
    setLinkInfo(state, payload) {
      state.linkInfo = payload
    },
    setQueryInfo(state, payload) {
      state.queryInfo = payload
    },
    setError(state, payload) {
      state.errInfo = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
